import React from 'react';
import { AppBar, Button, Chip, Grid, IconButton, Toolbar, Tooltip } from '@mui/material';
import './header.scss';
import { ConnectedUserDto } from '../../services/dtos/connected-user-dto';
import MenuHeader from './menu-header/menu-header';
import { Link } from 'react-router-dom';
import { AccountCircle, Logout } from '@mui/icons-material';
import { ROLE_ADMIN, ROLE_COMM } from '../../utils/constants.utils';
import { useAuth } from '../../hooks/use-auth.hook';

/**
 * Composant pour le header des pages
 *
 * Il contient deux affichages :
 * - Si l'utilisateur est connecté
 * - Si l'utilisateur n'est pas connecté
 * @param props
 * @constructor
 */
export default function Header(props: { img: string; isAuth: boolean; user: null | ConnectedUserDto }) {
    //AuthContext
    let auth = useAuth();

    // Affiche le menu profil si l'utilisateur est connecté
    let itemProfile = showItemsProfile(props.isAuth, props.user, auth);

    //Const utiles pour les chiffres
    const zero = 0;
    const two = 2;
    const three = 3;
    const four = 4;
    const five = 5;
    const six = 6;
    const eight = 8;

    //Taille grid : logo - mobile
    let sizeGridLogo = props.user?.roles?.some(role => role === ROLE_ADMIN || role === ROLE_COMM) ? five : eight;
    if (props.user?.roles?.some(role => role === ROLE_ADMIN || role === ROLE_COMM) && props.user?.tokenLoggedInAS) {
        sizeGridLogo = four;
    }

    //Taille grid : profile - mobile
    let sizeGridProfile = props.user?.roles?.some(role => role === ROLE_ADMIN || role === ROLE_COMM) ? five : two;
    if (props.user?.roles?.some(role => role === ROLE_ADMIN || role === ROLE_COMM) && props.user?.tokenLoggedInAS) {
        sizeGridProfile = six;
    }

    // Création du header
    const dataTestid = 'button-home';
    return (
        <AppBar
            position="static"
            className="container-header"
            color="transparent"
            elevation={0}
            sx={{ backgroundColor: 'white', paddingLeft: '10px', paddingRight: '10px' }}
        >
            {/* Composition du header */}
            <Toolbar disableGutters sx={{ display: { xs: 'none', md: 'flex' } }}>
                <Grid container spacing={1}>
                    {/* Logo SDDEA */}
                    <Grid item xs={4}>
                        <Button component={Link} data-testid={dataTestid} className={dataTestid} to={'/'}>
                            <img src={props.img} className={'logo-sddea'} alt="logo SDDEA" />
                        </Button>
                    </Grid>
                    {/* Bouton de retour à l'accueil */}
                    <Grid
                        item
                        xs={props.user?.roles?.some(role => role === ROLE_ADMIN || role === ROLE_COMM) ? three : four}
                    ></Grid>
                    {/* Menu admin (affiché si l'utilisateur est connecté et qu'il est admin) */}
                    {props.user?.roles?.some(role => role === ROLE_ADMIN || role === ROLE_COMM) && (
                        <Grid item xs={three}>
                            <MenuHeader name="admin" user={props.user} />
                        </Grid>
                    )}
                    {/* Menu du profil */}
                    <Grid
                        item
                        xs={props.user?.roles?.some(role => role === ROLE_ADMIN || role === ROLE_COMM) ? two : three}
                    >
                        {itemProfile}
                    </Grid>
                </Grid>
            </Toolbar>
            <Toolbar disableGutters sx={{ display: { xs: 'flex', md: 'none' } }}>
                {/* Header affiché sur petit écran */}
                <Grid container>
                    {/* Utilisation du menu hamburger */}
                    <Grid item xs={two}>
                        <MenuHeader name="burger" user={props.user} />
                    </Grid>
                    {/* Logo SDDEA */}
                    <Grid item xs={sizeGridLogo}>
                        <Button component={Link} className={dataTestid} data-testid={dataTestid} to={'/'}>
                            <img src={props.img} className={'logo-sddea'} alt="logo SDDEA" />
                        </Button>
                    </Grid>
                    {/* Menu du profil */}
                    <Grid item xs={sizeGridProfile}>
                        {itemProfile}
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
}

/**
 * Permet de gerer les items profile
 * @param isAuth is auth
 * @param user user
 * @param auth contexte d'auth
 */
function showItemsProfile(isAuth: boolean, user: null | ConnectedUserDto, auth: any) {
    //Règle d'affichage du nom
    let namePersonLoggedAs = '';
    if (user?.nomLoggedInAS) {
        namePersonLoggedAs += user?.nomLoggedInAS + ' ';
    }
    if (user?.prenomLoggedInAS) {
        namePersonLoggedAs += user?.prenomLoggedInAS;
    }

    return isAuth ? (
        <>
            <MenuHeader name="profile" user={user} />
            {/*Ajout d'un chip pour les admins*/}
            {user?.roles?.some(role => role === ROLE_ADMIN) && (
                <>
                    <Chip label={user?.tokenLoggedInAS ? namePersonLoggedAs : 'Admin'} color="primary" />
                    {user?.tokenLoggedInAS && (
                        <Tooltip title={'Se déconnecter en tant que'} arrow>
                            <IconButton
                                onClick={() => {
                                    auth.signoutLoggedInAs();
                                }}
                            >
                                <Logout color="error" />
                            </IconButton>
                        </Tooltip>
                    )}
                </>
            )}
        </>
    ) : (
        <Button component={Link} to={'/connexion'}>
            <AccountCircle sx={{ display: { xs: 'flex', md: 'none' } }} />
        </Button>
    );
}
